import { RematchDispatch } from '@rematch/core';
import { axiosErrorHandler } from 'common/helpers';
import { IRootModel } from 'app/store';
import { IAfterCallPayload } from 'entities/Calls/Twilio.models';
import { twilioService } from 'entities/Calls/Twilio.service';

export const twilioEffects = (dispatch: RematchDispatch<IRootModel>) => ({
  async getVoiceCallToken() {
    dispatch.twilio.setLoading(true);

    try {
      const response = await twilioService.getVoiceCallToken();
      dispatch.twilio.setToken(response.token);
    } catch (error) {
      axiosErrorHandler(error);
    } finally {
      dispatch.twilio.setLoading(false);
    }
  },
  async trackVoiceCallDuration(payload: IAfterCallPayload) {
    dispatch.twilio.setLoading(true);

    try {
      await twilioService.trackVoiceCallDuration(payload);
      dispatch.twilio.setDuration(null);
    } catch (error) {
      axiosErrorHandler(error);
    } finally {
      dispatch.twilio.setLoading(false);
    }
  },
  resetTwilioState() {
    dispatch.twilio.setToken(null);
    dispatch.twilio.setOnCall(false);
    dispatch.twilio.setDuration(null);
  },
});
